/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IBackupAssetReportQueryVariables = Types.Exact<{
  backupId: Types.Scalars['ID']['input'];
  backupAssetReportId: Types.Scalars['ID']['input'];
}>;

export type IBackupAssetReportQuery = {
  __typename?: 'Query';
  backupAssetReport?: {
    __typename?: 'BackupAssetReport';
    id: string;
    createdAt: any;
    period: any;
    backupAsset: { __typename?: 'BackupAsset'; id: string; name: string };
    data: {
      __typename?: 'ReportData';
      collaborators?: number | null;
      commitsPerDay?: any | null;
      languages?: any | null;
      size?: any | null;
      totalCommits?: number | null;
    };
  } | null;
};

export const BackupAssetReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'backupAssetReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'backupId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'backupAssetReportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backupAssetReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'backupId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'backupId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'backupAssetReportId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'backupAssetReportId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'period' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'backupAsset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'collaborators' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commitsPerDay' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'languages' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCommits' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IBackupAssetReportQuery, IBackupAssetReportQueryVariables>;
